export enum ButtonColor {
  danger = 'danger',
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
}

export enum ButtonType {
  button = 'button',
  submit = 'submit',
}

export enum IconColor {
  white = 'white',
  black = 'black',
}
